export const useStageConfiguration = () => ({
    stage: process.env.STAGE,
});
